import { z } from 'zod/v4'

// Primitive values allowed in leaf comparisons
// Note: dates should be encoded as ISO strings on the wire
const PrimitiveSchema = z.union([z.string(), z.number(), z.boolean()])

// StructuredFilter: { fieldHandle: { op: value | value[] } }
export const StructuredFilterSchema = z.record(
  z.string(),
  z.record(z.string(), z.union([PrimitiveSchema, z.array(PrimitiveSchema)])),
)

// StructuredExpression: StructuredFilter | { AND?: StructuredFilter[]; OR?: StructuredFilter[]; NOT?: StructuredFilter | StructuredExpression }
export const StructuredExpressionSchema: z.ZodType<unknown> = z.lazy(() =>
  z.union([
    StructuredFilterSchema,
    z
      .object({
        AND: z.array(StructuredFilterSchema).optional(),
        OR: z.array(StructuredFilterSchema).optional(),
        NOT: z
          .union([StructuredFilterSchema, StructuredExpressionSchema])
          .optional(),
      })
      .strict(),
  ]),
)

// Sort schema for CRM queries
export const SortItemSchema = z.object({
  key: z.string(),
  direction: z.enum(['asc', 'desc']).optional(),
})

export const SortSchema = z.union([SortItemSchema, z.array(SortItemSchema)])

// TypeScript types inferred from schemas
export type Primitive = z.infer<typeof PrimitiveSchema>
export type StructuredFilter = z.infer<typeof StructuredFilterSchema>

// Define StructuredExpression type more explicitly
export type StructuredExpression =
  | StructuredFilter
  | {
      AND?: StructuredFilter[]
      OR?: StructuredFilter[]
      NOT?: StructuredFilter | StructuredExpression
    }

export type SortItem = z.infer<typeof SortItemSchema>
export type Sort = z.infer<typeof SortSchema>
